import Sortable from "sortablejs";
import ApplicationsWizard from "./ApplicationsWizard";
import ApplicationsForm from "./ApplicationsForm";
import $ from "jquery";



$("#applications-wizard-wrap").each(function () {
    new ApplicationsWizard({}, this);
});

$("#application-add-form").each(function () {
    new ApplicationsForm($(this))
});

$("[data-sortable]").each(function () {
    new Sortable(this, {
        animation: 150,
        ghostClass: 'blue-background-class',
        handle: '.sortable-handler'
    });
})


const filterFormSelector = '[data-type="filter"]';
$('body').on('submit', filterFormSelector, function (e) {
    $(this).find("input,select").each(function () {
        if ($(this).val() == '') {
            $(this).attr("name", "").attr("disabled", "disabled");
        }
    });
    $(this)
        .find("button[type='submit'] > .fa-search")
        .removeClass('fa-search').addClass('fa-circle-notch fa-spin')
    ;
}).on('click', filterFormSelector + ' button[type="submit"]',function (e) {
    $(this.form).data('submit_invoker', $(this));
});

$('a[data-calc-sum]').on('click', function (e){
    e.preventDefault();
    let $wrap = $(this).parent();
    $.ajax({
        url: $(this).attr('href'),
        data: {
            _calc: 'sum'
        }
    }).done(function (response){
        $wrap.find('.preloader').replaceWith(response);
    })
    $(this).remove();
    $wrap.append('<div class="preloader spinner-border spinner-border-sm" role="status"><span class="sr-only">...</span></div>');

})